module.exports = __webpack_public_path__ + "static/media/luminous-BG_centr-vertical.19e33b7d.svg";